import api from "@/libs/axios";
import * as ep from "./endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    loadingSlider: true,
    loading: false,
    deleteLoading: false,
    slides: [],
  },
  getters: {
    slides(state) {
      return state.slides;
    },
    loadingSlider(state) {
      return state.loadingSlider;
    },
    loading(state) {
      return state.loading;
    },
    deleteLoading(state) {
      return state.deleteLoading;
    },
  },
  mutations: {
    setSlides(state, payload) {
      state.slides = payload;
    },
    setLoading(state, val) {
      state.loading = val;
    },
  },
  actions: {
    async editSlide({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.post(ep.edit_slide(payload.id), payload.fd);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        console.log(err);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setLoading", false);
      }
    },

    async createSlider({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.post(ep.get_slides, payload.fd);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        console.log(err);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setLoading", false);
      }
    },

    async deleteSlide({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.delete(ep.edit_slide(payload));
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        console.log(err);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
